import { render, staticRenderFns } from "./ConfigurePracticePulse.vue?vue&type=template&id=8c96b362&scoped=true"
import script from "./ConfigurePracticePulse.vue?vue&type=script&lang=js"
export * from "./ConfigurePracticePulse.vue?vue&type=script&lang=js"
import style0 from "./ConfigurePracticePulse.vue?vue&type=style&index=0&id=8c96b362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c96b362",
  null
  
)

export default component.exports